/* eslint-disable require-jsdoc */
import React from 'react';

export default function PrivacySummary() {
  return (
    <div className="privacy-container">
      <p>Before using this website, please read the Privacy Policy below.</p>
      <p>
        By using this website you agree to the terms of the Privacy Policy
        stated below. The Advanced Intelligence Services Corporation ("A.I.S.
        Corp.") and its affiliates and subsidiaries reserve the right to review
        and revise the Privacy Policy from time to time without prior notice
        and, by using this site subsequent to any revision of the Privacy
        Policy, you agree to be bound by such changes. If you find the Privacy
        Policy to be unacceptable, you must immediately terminate your use of
        this Website.
      </p>
      <br />

      <h2>A.I.S. Corp. Website Privacy Policy</h2>
      <p>
        Except as provided in this Privacy Policy, the A.I.S. Corp. website does
        not disclose individually identifiable information about its visitors to
        any third party without that visitor's consent.
      </p>
      <br />

      <h2>Privacy Philosophy</h2>
      <p>
        The information provided in this Privacy Policy covers your interactions
        on the different areas of the A.I.S. Corp. website referenced above
        (excludes the co-branded pages of our partners and affiliates).
      </p>
      <p>
        As a company, A.I.S. Corp. believes strongly in protecting online
        consumer privacy, and it is A.I.S. Corp.'s goal to allow our visitors to
        provide as much or as little information as they feel comfortable.
      </p>
      <br />

      <h2>Information Gathered</h2>
      <p>
        A.I.S. Corp. gathers information about our visitors that allows us to
        offer compelling and easily accessible online content in a manner that
        provides personal privacy protection as well. Occasionally we ask you to
        provide us certain personal information such as your name, email
        address, or a list of your interests and hobbies. You never have to
        answer these questions, although not answering them may limit the
        services that we can offer you. In order to comply with the Children's
        Online Privacy Protection Act ("COPPA"), A.I.S. Corp. does not knowingly
        collect any information from children under 13. In order to provide you
        with a personalized experience and also monitor the traffic patterns on
        our site, A.I.S. Corp. uses a feature of your browser called a "cookie"
        to track content preferences and traffic patterns. The cookie may
        contain a number or other information which reminds us who you are when
        you visit our site. This browser feature is valuable to you because it
        alleviates the need to re-register for services each time you visit our
        site and because it allows us to better understand traffic patterns
        throughout our website (keep track of how often visitors visit a
        particular part of our site) so we can offer our visitors the most
        popular and useful content and services available. You may choose not to
        accept cookies by changing the preferences on your browser. However,
        your experience will be less personalized and, in addition, certain
        services may not be available for your use (See below, "Use of the
        Information"). Other companies that advertise on our site also have the
        ability to assign a different cookie to you. You may choose not to
        accept such cookies by changing the preferences on your browser. To find
        out which advertising firms A.I.S. Corp. uses from time to time, see our
        list of Advertising Partners. Although you may visit our site
        anonymously, you may elect to provide us with information you want
        A.I.S. Corp. to remember. We hope that you will want to provide
        information about yourself to A.I.S. Corp. because it will make our
        website more valuable to you. If you are comfortable providing us with
        information about yourself, enhanced services are available to you that
        are impossible for us to offer to anonymous users. From time to time,
        A.I.S. Corp. will conduct surveys in order to help serve you better.
        Participation in the surveys is optional and anonymous.
      </p>
      <br />

      <h2>Use of the Information</h2>
      <p>
        A.I.S. Corp. always tries to provide you with a compelling reason to
        come back and visit our site again: We use the information gathered from
        you to provide personalized portions of our site that are intended to
        provide just the information you are interested in receiving. We analyze
        what our customers like and don't like about A.I.S. Corp.'s current
        offerings so that we can design better services. We use information
        about what you are searching for to help focus our energies on the
        services that we offer, hopefully to make them more valuable to you. We
        occasionally develop summary - not individual - reports for our
        advertisers. An example of a summary report might be "36,000 people
        clicked on Advertisement "X" today and, of those people, 53% had
        previously indicated they had an interest in sports." Our advertisers
        need this information to determine how effective their advertising
        investments are. Information Distribution Other companies which place
        advertising or content on our site may collect information about you by
        way of cookies when you view or click on their advertising or content.
        You should contact these advertisers or content providers directly if
        you have any questions about their use of this information. Refer to the
        section below for information on content providers. Additionally,
        although partners, affiliates and third parties may link to our website,
        or otherwise be associated with our website, A.I.S. Corp. cannot control
        the information collection and distribution policies of such parties.
        Although we do encourage our partners and affiliates, including
        co-branding partners, to adopt privacy policies similar to this one, we
        do not have control over the practices of third parties and these
        practices may differ from our own. You should check the privacy policy
        of every website you visit to ensure that you are comfortable with the
        practices of that particular website. If at any time you are uncertain
        about whether or not your personal information will be provided to
        A.I.S. Corp. or the content provider, please feel free to contact our
        Client Services Department.
      </p>
      <br />

      <h2>Disclosure of Personal Information</h2>
      <p>
        A.I.S. Corp. may disclose personal information if required to do so by
        law or in the good-faith belief that such action is necessary to (a)
        conform to the edicts of the law or comply with legal process served on
        A.I.S. Corp.; (b) protect and defend the rights or property of A.I.S.
        Corp., the site or the users of A.I.S. Corp., and (c) act under exigent
        circumstances to protect the personal safety of users of A.I.S. Corp.,
        the site or the public. A.I.S. Corp. may also disclose personal
        information with the user's consent, whether by opt-in, opt-out or other
        form of consent. Various A.I.S. Corp. services allow for information
        provided by users to be immediately posted in a public forum. Examples
        include chat rooms and message boards (see below), classifieds, White
        Pages, Yellow Pages and other services. Users providing information to
        such services should be familiar with the service and its public nature,
        and realize that the privacy of such information cannot be protected.
      </p>
      <br />

      <h2>Unsolicited Contact</h2>
      <p>
        A.I.S. Corp. does not endorse the sending of unsolicited email to its
        users without such user's consent and will use commercially reasonable
        efforts to enforce this action. A.I.S. Corp. may send administrative
        emails to confirm user registrations or to update users concerning new
        services or opportunities with A.I.S. Corp. Some of these emails may
        contain information about the services of our partners. We may send out
        promotional emails on behalf of our partners to those users who have
        demonstrated an interest in receiving such solicitations.
      </p>
      <br />

      <h2>Chat and Message Board Disclaimer</h2>
      <p>
        Information that you disclose about yourself in a public chat room,
        message board or other public forum will immediately become available to
        anyone who has access to those public areas. We cannot protect the
        privacy of information disclosed in these forums. While utilizing these
        areas, please restrict your disclosure of personal information to any
        information that you are willing to have available to the public.
      </p>
      <br />

      <h2>Notification of Changes</h2>
      <p>
        A.I.S. Corp. reserves the right to change this Privacy Policy from time
        to time. If A.I.S. Corp. changes this Privacy Policy with respect to the
        disclosure of your personally identifiable information, we will post a
        notice of such change on this website or contact users by email or other
        communication to obtain consent. We welcome any questions or comments
        you have; please send them to our Client Services Department.
      </p>
      <br />

      <h2>Security</h2>
      <p>
        A.I.S. Corp. takes the security of information very seriously.
        Information collected by A.I.S. Corp. is stored in secure operating
        environments. Thank you for visiting A.I.S. Corp.
      </p>
      <p>
        POLICY REGARDING COPYRIGHT INFRINGEMENT AND DESIGNATION OF A COPYRIGHT
        AGENT
      </p>
      <p>
        A.I.S. Corp.’s policy regarding copyright infringement, including its
        designated agents for receipt of copyright infringement claims pursuant
        to the Digital Millennium Copyright Act (17 USC § 512) is incorporated
        herein and follows below. A.I.S. Corp. respects the intellectual
        property rights of others and requires those that visit our website and
        use our network to do the same. A.I.S. Corp. may, in appropriate
        circumstances and at its discretion, remove or disable access to
        material on its website or its network that infringes upon the copyright
        rights of others. A.I.S. Corp. also may, at its discretion, remove or
        disable links or references to an online location that contains
        infringing material or infringing activity. In the event that any
        visitors to the website or users of our network repeatedly infringe on
        others copyrights, we may in our sole discretion terminate those
        individuals’ rights to use our website and/or network. If you believe
        that your work has been used on our website or network in any manner
        that constitutes copyright infringement, please notify A.I.S. Corp.'s
        copyright agents by written notice. The notice should include the
        following information: An electronic or physical signature of a person
        authorized to act on behalf of the owner of the copyright allegedly
        infringed; A description of the copyrighted work you claim has been
        infringed, including a copy of the copyrighted work or the web page
        address where the copyrighted work may be found; Identification of the
        location on our website of the material you claim has been infringed, or
        the link or reference to another website that contains the material you
        claim has been infringed; Your name, address, telephone number and
        e-mail address; A statement by you that you have a good faith belief
        that the disputed use of the material at issue is not authorized by the
        copyright owner, the agent of the copyright owner or the law; and A
        statement by you that the information in this notification is accurate
        and a statement, under penalty of perjury, that you are the copyright
        owner of the material allegedly infringed or authorized to act on the
        copyright owner's behalf. A.I.S. Corp.'s copyright agents for notice of
        claims of copyright infringement on this website and our network can be
        reached at following:
      </p>
      <p>
        <b>By telephone</b>: 1-800-427-9479
      </p>
      <p>
        <b>By E-mail</b>: services@aisincorporated.com
      </p>
      <p>
        DISCLAIMER A.I.S. Corp. is a biological and artificial intelligence
        research provider, exclusively serving the United States Department of
        Defense and it’s long-term allies in emerging defense contexts. A.I.S.
        Corp. is based in the USA. Copyright © 2021, 2022 Advanced Intelligence
        Services Corporation All rights reserved.
      </p>
    </div>
  );
}
